// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2DA-9","itemTitle":"ClientEmergencyInfo_itemTitle__7k8po","itemText":"ClientEmergencyInfo_itemText__1FxDD"};